// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { Calendar } from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import Switch from 'react-switch'
import { useDispatch } from 'react-redux'
import {
  AvailabilityTypeSettings,
  Dropdown,
  PopUp,
  getDefaultVisitTypeGroup,
  shouldShowVisitTypeGroupPicker,
  // @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
} from 'ui_kit_qmd'
import moment from 'moment-timezone'
import classNames from 'classnames'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { isEmpty } from 'lodash'
import closeIcon from '../../../images/common/close.png'
import './AvailabilityPopUp.scss'
import { PrimaryButton } from '../../../components/ui_kit_quickMD/primary-button/primarybutton'
import { setError, setIsSuccessScheduleEdit } from '../../../store/calendar/CalendarActions'
import { addToSchedule, editSchedule } from '../../../store/calendar/CalendarThunk'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import calendarIcon from '../../../images/common/calendar.png'
import clockIcon from '../../../images/common/clock.png'
import {
  getDaysOfWeekFromAbbreviationArr,
  getOnlyFutureAvailableTimes,
  getTabId,
  getTimeOptionsList,
  replaceTimeZone,
  toTimeZone,
} from '../../../utils/common'
import RecurrenceSettings from './recurrence-settings/RecurrenceSettings'
import { useProviderLocations } from '../../../api/hooks/useProviderLocations'
import LocationSelector from './LocationSelector'
import { useSelector } from 'store/hooks/useSelector'

const dateChangeDropdownIconStyle = {
  width: 24,
  height: 24,
  right: 18,
  top: 18,
  transform: 'none',
}
const dateDropDownContainerStyle = {
  width: 411,
}

const availabilityPopUpDateDropdownContainerStyle = {
  width: 411,
  height: 350,
  marginTop: 8,
}
const availabilityPopUpTimeDropdownContainerStyle = {
  width: 411,
  marginTop: 8,
}
const endDateDropDownCustomIconStyle = {
  width: 24,
  height: 24,
  right: 18,
  top: 18,
  transform: 'none',
}
const availabilityPopUpSaveBtnContainerStyle = {
  width: 422,
  height: 60,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: 24,
}

const AvailabilityPopUp = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  viewType,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  closePopUpCallback,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  startDate,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  endDate,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  clickedStartDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  clickedEndDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setClickedStartDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setClickedEndDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  occurrenceId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isRecursive,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isEditMode,
  repeatDays = [],
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  recurrenceEndDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  scheduleId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  scheduleOrder,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setStartDateHandler,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isShowSelectRecursionChangeModePopUp,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsSelectModePopUp,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  occurrenceOrder,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isRecurrenceOn,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  toggleIsRecurrenceOn,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  daysOfWeekRef,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  calendarTimeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTypeGroups,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTypeGroupId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setShowEditPopUpView,
}) => {
  const tabId = getTabId()
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const scheduleInfoFrom = useSelector((state) => state.calendarPageReducer.scheduleInfoFrom)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const scheduleInfoTo = useSelector((state) => state.calendarPageReducer.scheduleInfoTo)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const scheduleInfoTreatmentCenter = useSelector((state) => state.calendarPageReducer.scheduleInfoTreatmentCenter)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const calendarSchedule = useSelector((state) => state.calendarPageReducer[tabId]?.schedule ?? [])
  const dispatch = useDispatch()
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const editScheduleSuccess = useSelector((state) => state.calendarPageReducer.editScheduleSuccess)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const recurringBaseTimeZone = useSelector((state) => state.calendarPageReducer.recurringBaseTimeZone)

  const [isFirstRender, setIsFirstRender] = useState(true)
  const [isStartTimeChanged, setIsStartTimeChanged] = useState(false)
  const [isFirstRepeatEndDateValueChanged, setIsFirstRepeatEndDateValueChanged] = useState(true)
  const [repeatsSelectError, setRepeatsSelectError] = useState('')
  const [height, setHeight] = useState(768)
  const [prevSelectedDays, setPrevSelectedDays] = useState(repeatDays)
  const [isTimeAdjustedAccordinglyNotFullTimeOptionsList, setIsTimeAdjustedAccordinglyNotFullTimeOptionsList] =
    useState(false)
  const [isRecurrenceEndDateChanged, setIsRecurrenceEndDateChanged] = useState(false)
  const [repeatEndDate, setRepeatEndDate] = useState(recurrenceEndDateTime || '')
  const currentHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight

  const [selectedOption, setSelectedOption] = useState([
    { value: 'Never', isChecked: !recurrenceEndDateTime?.dateTime },
    { value: 'On', isChecked: !!recurrenceEndDateTime?.dateTime },
  ])
  const matchedSavedVisitTypeGroup =
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    visitTypeGroupId ? visitTypeGroups.find((item) => item.VisitTypeGroupId === visitTypeGroupId) : undefined
  const defaultVisitTypeGroup = getDefaultVisitTypeGroup(visitTypeGroups) ?? visitTypeGroups[0]
  // If the saved id no longer matches any group (e.g. group was deleted), fall back to
  // the provider's default group so the popup can still render and the user has a path
  // forward — but flag it visibly via the banner below so they know to verify before saving.
  const initialVisitTypeGroup =
    visitTypeGroupId ? (matchedSavedVisitTypeGroup ?? defaultVisitTypeGroup) : defaultVisitTypeGroup
  const [visitTypeGroup, setVisitTypeGroup] = useState(initialVisitTypeGroup)
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const isSavedVisitTypeGroupMissing = !!visitTypeGroupId && !matchedSavedVisitTypeGroup
  const showVisitTypePicker = shouldShowVisitTypeGroupPicker(visitTypeGroups)
  // In-person availability is driven by the selected visit-type group, identified by
  // its "IP" abbreviation (temporary signal until the BE adds an explicit flag).
  const isInPerson = (visitTypeGroup?.Abbreviation ?? '').toLowerCase() === 'ip'
  const { locations: providerLocations, loading: locationsLoading } = useProviderLocations()
  const [selectedLocation, setSelectedLocation] = useState(null)
  const [locationSaveAttempted, setLocationSaveAttempted] = useState(false)

  // When editing an existing in-person block, restore isInPerson + selectedLocation.
  useEffect(() => {
    if (!isEditMode || providerLocations.length === 0) return
    let treatmentCenter = scheduleInfoTreatmentCenter
    // Fallback for non-recurring occurrences (no ScheduleId → no schedule fetch):
    // read TreatmentCenter directly from the already-loaded calendar occurrence data.
    if (!treatmentCenter && occurrenceId && calendarSchedule.length) {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const occurrence = calendarSchedule.find((scheduleOccurrence) => scheduleOccurrence.OccurrenceId === occurrenceId)
      treatmentCenter = occurrence?.TreatmentCenter ?? null
    }
    if (!treatmentCenter) return
    const matchingLocation = providerLocations.find(
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      (location) => location.TreatmentCenterId === treatmentCenter.TreatmentCenterId,
    )
    setSelectedLocation(matchingLocation ?? treatmentCenter)
  }, [isEditMode, scheduleInfoTreatmentCenter, providerLocations, occurrenceId, calendarSchedule])
  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  const isOnSelected = selectedOption[1].isChecked
  const fromDateTimeInCorrectFormat = moment(clickedStartDateTime.dateTime).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
  const toDateTimeInCorrectFormat = moment(clickedEndDateTime.dateTime).format('YYYY-MM-DDTHH:mm:ss.SSSZ')

  const onSetVisitTypeGroup = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const group = visitTypeGroups.find((item) => item.Name === value)
      if (!group) return
      const groupIsInPerson = (group.Abbreviation ?? '').toLowerCase() === 'ip'
      setVisitTypeGroup(group)
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      setShowEditPopUpView?.((prev) => ({ ...prev, visitTypeGroupId: group.VisitTypeGroupId }))
      if (!groupIsInPerson) {
        setSelectedLocation(null)
        setLocationSaveAttempted(false)
      }
    },
    [visitTypeGroups],
  )
  // If the parent loads visitTypeGroups async, the first render may see [] and
  // visitTypeGroup falls through to undefined. Once groups arrive, settle on
  // either the saved match or the first group — without overriding a manual pick.
  useEffect(() => {
    if (!visitTypeGroup && visitTypeGroups.length > 0) {
      const fallback = getDefaultVisitTypeGroup(visitTypeGroups) ?? visitTypeGroups[0]
      const settled =
        visitTypeGroupId ?
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          (visitTypeGroups.find((item) => item.VisitTypeGroupId === visitTypeGroupId) ?? fallback)
        : fallback
      setVisitTypeGroup(settled)
    }
  }, [visitTypeGroups, visitTypeGroupId, visitTypeGroup])
  useEffect(() => {
    setHeight(currentHeight)
    return () => {
      toggleIsRecurrenceOn(false)
    }
  }, [])

  useEffect(() => {
    const isRecurrenceEndDateNotChanged = recurrenceEndDateTime?.dateTime === repeatEndDate?.dateTime

    if (isRecurrenceEndDateNotChanged) {
      setIsRecurrenceEndDateChanged(false)
    } else {
      setIsRecurrenceEndDateChanged(true)
    }
  }, [repeatEndDate])

  useEffect(() => {
    if (editScheduleSuccess) {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(setIsSuccessScheduleEdit(false))
    }
  }, [editScheduleSuccess])

  useLayoutEffect(() => {
    if (viewType === 'PNB') {
      if (!isEditMode) {
        const substractedDate = moment(
          moment(clickedStartDateTime.dateTime).add(1, 'hour').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        )
        setClickedEndDateTime({
          displayDate: substractedDate.format('dddd MMM D YYYY'),
          displayTime: substractedDate.format('hh:mm a'),
          dateTime: substractedDate.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        })
      }
    }

    setIsFirstRender(false)
  }, [])
  useLayoutEffect(() => {
    if (isEditMode && isRecursive) {
      toggleIsRecurrenceOn(true)
    }
  }, [])

  useEffect(() => {
    if (isRecurrenceOn) {
      document.body.style.minHeight = '920px'
      document.body.style.maxHeight = '100%'
      document.body.style.height = '100%'
    } else {
      document.body.style.height = ''
      document.body.style.minHeight = ''
      document.body.style.maxHeight = ''
    }
    return () => {
      document.body.style.height = ''
      document.body.style.minHeight = ''
      document.body.style.maxHeight = ''
    }
  }, [isRecurrenceOn])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const changeDateTime = (value, type) => {
    switch (type) {
      case 'startTime': {
        const date = moment.utc(startDate.dateTime)
        const correctTimeZoneRow = toTimeZone(date, calendarTimeZone).format().toString()
        const formattedTime = moment(value, 'h:mma').format('HH:mm:00.000')
        const modifiedString = correctTimeZoneRow.slice(0, 11) + formattedTime + correctTimeZoneRow.slice(19)

        const newClickedStartDateTime = {
          displayDate: startDate.displayDate,
          displayTime: value,
          dateTime: modifiedString,
        }
        setClickedStartDateTime(newClickedStartDateTime)
        if (setStartDateHandler) {
          setStartDateHandler(isRecursive, isRecurrenceOn, newClickedStartDateTime, 'startTime')
        }
        setIsStartTimeChanged(true)
        break
      }
      case 'endTime': {
        const date = moment.utc(endDate.dateTime)
        const correctTimeZoneRow = toTimeZone(date, calendarTimeZone).format().toString().replace('Z', '+00:00')

        const formattedTime = moment(value, 'h:mma').format('HH:mm:00.000')
        const modifiedString = correctTimeZoneRow.slice(0, 11) + formattedTime + correctTimeZoneRow.slice(19)
        const correctTimeZoneDay = replaceTimeZone(endDate.dateTime, modifiedString)

        const newClickedEndDateTime = {
          displayDate: endDate.displayDate,
          displayTime: value,
          dateTime: correctTimeZoneDay,
        }
        setClickedEndDateTime(newClickedEndDateTime)
        if (setStartDateHandler) {
          setStartDateHandler(isRecursive, isRecurrenceOn, newClickedEndDateTime, 'endTime')
        }
        break
      }
      default:
        break
    }
  }

  useEffect(() => {
    if (isTimeAdjustedAccordinglyNotFullTimeOptionsList) {
      setIsTimeAdjustedAccordinglyNotFullTimeOptionsList(false)
      return
    }
    if (isStartTimeChanged) {
      const newCorrectEndDate = moment(startDate.dateTime).add(4, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      setClickedEndDateTime({
        displayDate: moment(newCorrectEndDate).format('dddd MMM D YYYY'),
        displayTime: moment(newCorrectEndDate).format('hh:mm a'),
        dateTime: newCorrectEndDate,
      })
      setIsStartTimeChanged(false)
    } else if (!isFirstRender) {
      const newCorrectEndDate = moment(startDate.dateTime).add(4, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      setClickedEndDateTime({
        displayDate: moment(newCorrectEndDate).format('dddd MMM D YYYY'),
        displayTime: moment(newCorrectEndDate).format('hh:mm a'),
        dateTime: newCorrectEndDate,
      })
    }
    if (viewType === 'PNB') {
      if (isStartTimeChanged) {
        const newCorrectEndDate = moment(startDate.dateTime).add(1, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        setClickedEndDateTime({
          displayDate: moment(newCorrectEndDate).format('dddd MMM D YYYY'),
          displayTime: moment(newCorrectEndDate).format('hh:mm a'),
          dateTime: newCorrectEndDate,
        })
        setIsStartTimeChanged(false)
      } else if (!isFirstRender) {
        const date = moment(startDate.dateTime).format('dddd MMM D YYYY')
        const time = moment(endDate.dateTime).format('hh:mm a')
        const newCorrectEndDate = moment(`${date} ${time}`).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        setClickedEndDateTime({
          displayDate: moment(newCorrectEndDate).format('dddd MMM D YYYY'),
          displayTime: moment(newCorrectEndDate).format('hh:mm a'),
          dateTime: newCorrectEndDate,
        })
      }
    }
  }, [startDate])

  // FIXME refactor/decouple - to improve readability and maintainability
  const onPressSave = useCallback(() => {
    if (!visitTypeGroup) return
    if (isInPerson && !selectedLocation) {
      setLocationSaveAttempted(true)
      return
    }
    const daysOfWeekList = getDaysOfWeekFromAbbreviationArr(daysOfWeekRef?.current?.getActiveDays())
    const isRepeatDaysWasChanged = daysOfWeekRef?.current?.isRepeatDaysWasChanged()
    const isAvailabilityViewType = viewType === 'availability'
    const errorExtraLabel = isAvailabilityViewType ? 'availability' : 'prevent new booking'
    const requestDataType = isAvailabilityViewType ? 'availability' : 'unavailability'

    if (!moment(clickedStartDateTime.dateTime).isAfter(moment(new Date())) && !isEditMode) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(errorCodes.CANT_SAVE_PAST_DATE, errorExtraLabel))
    } else if (moment(clickedEndDateTime.dateTime).isBefore(moment(clickedStartDateTime.dateTime))) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(errorCodes.END_BEFORE_START, errorExtraLabel))
    } else if (moment(clickedEndDateTime.dateTime).isSame(moment(clickedStartDateTime.dateTime))) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(errorCodes.END_BEFORE_START, errorExtraLabel))
    } else if (moment(clickedStartDateTime.dateTime).add(24, 'hours').isBefore(moment(clickedEndDateTime.dateTime))) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(errorCodes.MORE_THAN_24_HOURS_EVENT, errorExtraLabel))
    } else if (isRecurrenceOn && !daysOfWeekList.length) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(errorCodes.FILL_ALL_FIELDS))
      setRepeatsSelectError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, '', 'Repeats on'))
    } else if (
      isRecurrenceOn &&
      moment(repeatEndDate.displayDate).isBefore(moment(clickedEndDateTime.displayDate)) &&
      !isEditMode
    ) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(errorCodes.REPEAT_TIME_AFTER_END))
    } else if (isEditMode) {
      if ((isRecurrenceEndDateChanged || isRepeatDaysWasChanged) && isRecurrenceOn && isRecursive) {
        if (occurrenceOrder === 0) {
          const requestEditFirstOccurrenceInScheduleBody = {
            TimeZone: recurringBaseTimeZone || calendarTimeZone,
            Schedules: {
              Edit: [
                {
                  ScheduleId: scheduleId,
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                  FromDateTime: fromDateTimeInCorrectFormat,
                  ToDateTime: toDateTimeInCorrectFormat,
                  Type: requestDataType,
                  RecurringSettings: {
                    EndDateTime: isOnSelected ? repeatEndDate.dateTime : null,
                    WeekDays: daysOfWeekList,
                  },
                },
              ],
            },
          }
          dispatch(
            editSchedule({
              scheduleInfo: requestEditFirstOccurrenceInScheduleBody,
              eventType: requestDataType,
              tabId,
            }),
          )
        } else {
          const requestEditNonFirstOccurrenceInScheduleBody = {
            TimeZone: recurringBaseTimeZone || calendarTimeZone,
            Schedules: {
              Create: [
                {
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                  FromDateTime: moment(clickedStartDateTime.dateTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                  ToDateTime: moment(clickedEndDateTime.dateTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                  Type: viewType === 'availability' ? 'availability' : 'unavailability',
                  RecurringSettings: {
                    EndDateTime: isOnSelected ? repeatEndDate.dateTime : null,
                    WeekDays: daysOfWeekList,
                  },
                },
              ],
              Edit: [
                {
                  ScheduleId: scheduleId,
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                  FromDateTime: scheduleInfoFrom,
                  ToDateTime: scheduleInfoTo,
                  RecurringSettings: {
                    EndDateTime: moment(clickedEndDateTime.dateTime)
                      .subtract(1, 'days')
                      .utc()
                      .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                    WeekDays: repeatDays,
                  },
                },
              ],
            },
          }
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(editSchedule({ scheduleInfo: requestEditNonFirstOccurrenceInScheduleBody, tabId }))
        }
        return
      }
      if (isShowSelectRecursionChangeModePopUp) {
        setIsSelectModePopUp(true)
        return
      }
      const calendarTitleEle = document.getElementById('calendar-title')
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      calendarTitleEle.setAttribute('data-is-ready-to-click', 'false')
      if (isRecurrenceOn) {
        if (!isRecursive) {
          const correctEditScheduleBody = {
            TimeZone: recurringBaseTimeZone || calendarTimeZone,
            Occurrences: {
              Delete: [occurrenceId],
            },
            Schedules: {
              Create: [
                {
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                  FromDateTime: fromDateTimeInCorrectFormat,
                  ToDateTime: toDateTimeInCorrectFormat,
                  RecurringSettings:
                    isRecurrenceOn ?
                      {
                        EndDateTime: isOnSelected ? repeatEndDate.dateTime : null,
                        WeekDays: daysOfWeekList,
                      }
                    : null,
                  Type: requestDataType,
                },
              ],
            },
          }
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(editSchedule({ scheduleInfo: correctEditScheduleBody, tabId }))
        } else {
          dispatch(
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            editSchedule({
              scheduleInfo: {
                TimeZone: recurringBaseTimeZone || calendarTimeZone,
                Schedules: {
                  Create: [
                    {
                      VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                      TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                      ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                      FromDateTime: fromDateTimeInCorrectFormat,
                      ToDateTime: toDateTimeInCorrectFormat,
                      Type: viewType === 'availability' ? 'availability' : 'unavailability',
                      RecurringSettings: {
                        EndDateTime: isOnSelected ? moment(repeatEndDate.dateTime).add(1, 'day') : null,
                        WeekDays: daysOfWeekList,
                      },
                    },
                  ],
                  Edit: [
                    {
                      ScheduleId: scheduleId,
                      VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                      TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                      ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                      FromDateTime: scheduleInfoFrom,
                      ToDateTime: scheduleInfoTo,
                      RecurringSettings: {
                        EndDateTime: moment(clickedEndDateTime.dateTime)
                          .subtract(1, 'days')
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                        WeekDays: repeatDays,
                      },
                    },
                  ],
                },
              },
              tabId,
            }),
          )
        }
      } else if (isRecursive) {
        if (scheduleOrder === 0) {
          const requestEditFirstOccurrenceInScheduleBody = {
            TimeZone: recurringBaseTimeZone || calendarTimeZone,
            Schedules: {
              Delete: [scheduleId],
            },
            Occurrences: {
              Create: [
                {
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                  FromDateTime: fromDateTimeInCorrectFormat,
                  ToDateTime: toDateTimeInCorrectFormat,
                  Type: requestDataType,
                },
              ],
            },
          }
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(editSchedule({ scheduleInfo: requestEditFirstOccurrenceInScheduleBody, tabId }))
        } else {
          const requestEditNonFirstOccurrenceInScheduleBody = {
            TimeZone: recurringBaseTimeZone || calendarTimeZone,
            Schedules: {
              Edit: [
                {
                  ScheduleId: scheduleId,
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                  FromDateTime: scheduleInfoFrom,
                  ToDateTime: scheduleInfoTo,
                  Type: requestDataType,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  StateCodes: isInPerson && selectedLocation ? [selectedLocation.StateCode] : [],
                  RecurringSettings: {
                    EndDateTime: moment(clickedStartDateTime.dateTime)
                      .subtract(1, 'days')
                      .format('YYYY-MM-DDT00:00:00.SSSZ'),
                    WeekDays: repeatDays,
                  },
                },
              ],
            },
            Occurrences: {
              Create: [
                {
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                  FromDateTime: fromDateTimeInCorrectFormat,
                  ToDateTime: toDateTimeInCorrectFormat,
                  Type: requestDataType,
                },
              ],
            },
          }
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(editSchedule({ scheduleInfo: requestEditNonFirstOccurrenceInScheduleBody, tabId }))
        }
      } else {
        dispatch(
          editSchedule({
            scheduleInfo: {
              TimeZone: recurringBaseTimeZone || calendarTimeZone,
              Occurrences: {
                Edit: [
                  {
                    ScheduleId: scheduleId,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                    TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                    ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                    OccurrenceId: occurrenceId,
                    FromDateTime: fromDateTimeInCorrectFormat,
                    ToDateTime: toDateTimeInCorrectFormat,
                    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                    StateCodes: isInPerson && selectedLocation ? [selectedLocation.StateCode] : [],
                  },
                ],
              },
            },
            eventType: requestDataType,
            tabId,
          }),
        )
      }
    } else {
      const calendarTitleEle = document.getElementById('calendar-title')
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      calendarTitleEle.setAttribute('data-is-ready-to-click', 'false')
      if (isRecurrenceOn) {
        dispatch(
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          addToSchedule({
            TimeZone: calendarTimeZone,
            Schedules: {
              Create: [
                {
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                  FromDateTime: fromDateTimeInCorrectFormat,
                  ToDateTime: toDateTimeInCorrectFormat,
                  RecurringSettings:
                    isRecurrenceOn ?
                      {
                        EndDateTime: isOnSelected ? repeatEndDate.dateTime : null,
                        WeekDays: daysOfWeekList,
                      }
                    : null,
                },
              ],
            },
            tabId,
          }),
        )
      } else {
        dispatch(
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          addToSchedule({
            TimeZone: calendarTimeZone,
            Occurrences: {
              Create: [
                {
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  TreatmentCenterId: isInPerson ? (selectedLocation?.TreatmentCenterId ?? null) : null,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation ? { StateCodes: [selectedLocation.StateCode] } : {}),
                  FromDateTime: fromDateTimeInCorrectFormat,
                  ToDateTime: toDateTimeInCorrectFormat,
                  Type: requestDataType,
                },
              ],
            },
            tabId,
          }),
        )
      }
      closePopUpCallback(true)
    }
  }, [
    visitTypeGroup,
    calendarTimeZone,
    clickedEndDateTime.dateTime,
    clickedEndDateTime.displayDate,
    clickedStartDateTime.dateTime,
    closePopUpCallback,
    daysOfWeekRef,
    dispatch,
    fromDateTimeInCorrectFormat,
    isEditMode,
    isInPerson,
    isOnSelected,
    isRecurrenceEndDateChanged,
    isRecurrenceOn,
    isRecursive,
    isShowSelectRecursionChangeModePopUp,
    occurrenceId,
    occurrenceOrder,
    recurringBaseTimeZone,
    repeatDays,
    repeatEndDate.dateTime,
    repeatEndDate.displayDate,
    scheduleId,
    scheduleInfoFrom,
    scheduleInfoTo,
    scheduleOrder,
    selectedLocation,
    setIsSelectModePopUp,
    tabId,
    toDateTimeInCorrectFormat,
    viewType,
  ])

  const timesArrayForSelectedDay = getTimeOptionsList()
  const timesArrayForToday = getOnlyFutureAvailableTimes(getTimeOptionsList(), new Date())
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const generateTimeOptionsByDate = (value) =>
    !moment(value ?? startDate.displayDate).isAfter(new Date()) ? timesArrayForToday : timesArrayForSelectedDay

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const changeDate = (value, type) => {
    const newDisplayDate = moment(new Date(value)).format('dddd MMM D YYYY')
    const correctTime = moment(startDate.displayTime, 'h:mm:ss A').format('HH:mm:ss')
    const isFullTimeList = generateTimeOptionsByDate(value).length === 96

    switch (type) {
      case 'startDate':
        const dataForRenderStart = moment(`${newDisplayDate} ${correctTime.toString()}`).format(
          'YYYY-MM-DDTHH:mm:ss.SSSZ',
        )
        const newClickedStartDateTime = {
          displayDate: newDisplayDate,
          displayTime: isFullTimeList ? startDate.displayTime : generateTimeOptionsByDate(value)[0],
          dateTime: dataForRenderStart,
        }
        if (!isFullTimeList) {
          const correctTimeStart = moment(generateTimeOptionsByDate(value)[0], 'h:mm:ss A').format('HH:mm:ss')
          const dateForCorrectEndDate = moment(`${newDisplayDate} ${correctTimeStart.toString()}`).format(
            'YYYY-MM-DDTHH:mm:ss.SSSZ',
          )
          const newCorrectEndDate = moment(dateForCorrectEndDate).add(4, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
          setClickedEndDateTime({
            displayDate: moment(newCorrectEndDate).format('dddd MMM D YYYY'),
            displayTime: moment(newCorrectEndDate).format('hh:mm a'),
            dateTime: newCorrectEndDate,
          })
          setIsTimeAdjustedAccordinglyNotFullTimeOptionsList(true)
        }
        setClickedStartDateTime(newClickedStartDateTime)
        if (setStartDateHandler) {
          setStartDateHandler(isRecursive, isRecurrenceOn, newClickedStartDateTime, 'startTime')
        }
        break
      case 'endDate':
        const changedDateEnd = new Date(
          `${moment(newDisplayDate).format('YYYY-MM-DD')}T${moment(endDate.displayTime, 'hh:mm a')
            .format('HH:mm:ss')
            .toString()}`,
        )
        const dataForRenderEnd = moment(changedDateEnd).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        const newClickedEndDateTime = {
          displayDate: newDisplayDate,
          displayTime: endDate.displayTime,
          dateTime: dataForRenderEnd,
        }
        setClickedEndDateTime(newClickedEndDateTime)
        if (setStartDateHandler) {
          setStartDateHandler(isRecursive, isRecurrenceOn, newClickedEndDateTime, 'endTime')
        }
        break
      case 'repeatEndDate':
        setRepeatEndDate({
          displayDate: newDisplayDate,
          dateTime: moment(new Date(value))
            .set({
              hour: 0,
              minute: 0,
              second: 0,
            })
            .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        })
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (setStartDateHandler) {
      if (isRecursive && !isRecurrenceOn) {
        setStartDateHandler(isRecursive, isRecurrenceOn, '', 'startTime')
        setStartDateHandler(isRecursive, isRecurrenceOn, '', 'endTime')
      } else {
        setStartDateHandler(isRecursive, isRecurrenceOn, clickedStartDateTime, 'startTime')
        setStartDateHandler(isRecursive, isRecurrenceOn, clickedEndDateTime, 'endTime')
      }
    }
  }, [isRecurrenceOn])

  const defaultEndRecurrenceDay = useMemo(
    () => ({
      displayDate: moment(clickedEndDateTime.dateTime)
        .set({ hour: 0, minute: 0, second: 0 })
        .add(1, 'day')
        .format('dddd MMM D YYYY'),
      dateTime: moment(clickedEndDateTime.dateTime)
        .set({ hour: 0, minute: 0, second: 0 })
        .add(1, 'day')
        .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    }),
    [clickedEndDateTime.dateTime],
  )

  const onChangeSwitch = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      toggleIsRecurrenceOn(value)
      if (!isRecursive && isFirstRepeatEndDateValueChanged) {
        setRepeatEndDate(defaultEndRecurrenceDay)
      }
    },
    [defaultEndRecurrenceDay, isFirstRepeatEndDateValueChanged, isRecursive, toggleIsRecurrenceOn],
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetEndDateOption = (newOptionValue) => {
    setIsRecurrenceEndDateChanged(true)
    if (newOptionValue === 'On') {
      setRepeatEndDate(defaultEndRecurrenceDay)
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetRepeatEndDateValue = (value, type) => {
    setIsFirstRepeatEndDateValueChanged(false)
    changeDate(value, type)
  }

  const startTimeOptions = () =>
    !moment(startDate.displayDate).isAfter(new Date()) ? timesArrayForToday : timesArrayForSelectedDay

  return (
    <PopUp
      className={classNames('calendar-availability-pop-up-container', {
        adjustedHeight: isRecurrenceOn,
      })}
      content={
        <>
          <img
            alt='Close'
            src={closeIcon}
            role='presentation'
            className='availability-close-img'
            onClick={() => {
              closePopUpCallback(false)
              toggleIsRecurrenceOn(false)
            }}
          />
          {viewType === 'availability' && (
            <label htmlFor='null' className='availability-title'>
              {isEditMode ? 'Edit availability' : 'New availability'}
            </label>
          )}
          {viewType === 'PNB' && (
            <label htmlFor='null' className='availability-title'>
              {isEditMode ? 'Edit Prevent new bookings' : 'Prevent new bookings'}
            </label>
          )}
          <div className='availability-datetimepicker-container'>
            <div className='availability-datetimepicker-box'>
              <Dropdown
                isDisabled={isRecursive ? isEditMode : null}
                isDateCase
                isCalendarOptions
                containerStyle={dateDropDownContainerStyle}
                dropdownContainerStyle={availabilityPopUpDateDropdownContainerStyle}
                value={moment(startDate.displayDate).format('dddd MMM DD YYYY')}
                calendarValue={startDate.displayDate}
                // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                setCalendarValue={(value) => changeDate(value, 'startDate')}
                dropId='Start date*'
                label='Start date*'
                customIcon={calendarIcon}
                isShowStar
                customIconStyles={dateChangeDropdownIconStyle}
                minCalendarDate={
                  timesArrayForToday.length === 0 ?
                    new Date(moment().parseZone().tz(calendarTimeZone, false).add(1, 'day').format('YYYY-MM-DD HH:mm'))
                  : new Date(moment().parseZone().tz(calendarTimeZone, false).format('YYYY-MM-DD HH:mm'))
                }
                Calendar={Calendar}
              />
              <Dropdown
                isDateCase
                scrollToValue
                options={startTimeOptions}
                isWithGeneratedOnTheFlyOptions
                containerStyle={{
                  width: '411px',
                }}
                dropdownContainerStyle={availabilityPopUpTimeDropdownContainerStyle}
                value={startDate.displayTime.replaceAll(' ', '')}
                // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                setValue={(value) => changeDateTime(value, 'startTime')}
                dropId='Start time*'
                label='Start time*'
                isError={false}
                localError={false}
                isShowStar
                customIcon={clockIcon}
                customIconStyles={dateChangeDropdownIconStyle}
              />
            </div>
            <div className='availability-line-break' />
            <div className='availability-datetimepicker-box'>
              <Dropdown
                isDisabled={isRecursive ? isEditMode : null}
                isDateCase
                showAbove={!isRecurrenceOn && height < 1080}
                isCalendarOptions
                containerStyle={dateDropDownContainerStyle}
                dropdownContainerStyle={availabilityPopUpDateDropdownContainerStyle}
                value={moment(endDate.displayDate).format('dddd MMM DD YYYY')}
                calendarValue={endDate.displayDate}
                // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                setCalendarValue={(value) => changeDate(value, 'endDate')}
                dropId='End date*'
                label='End date*'
                maxDate={moment(clickedStartDateTime.dateTime)
                  .parseZone()
                  .tz(calendarTimeZone, true)
                  .add(24, 'hours')
                  .format('YYYY-MM-DDTHH:mm:ss.SSSZ')}
                isShowStar
                customIcon={calendarIcon}
                customIconStyles={endDateDropDownCustomIconStyle}
                minCalendarDate={
                  new Date(moment(startDate.dateTime).parseZone().tz(calendarTimeZone, true).format('YYYY-MM-DD HH:mm'))
                }
                Calendar={Calendar}
              />
              <Dropdown
                isShowStar
                isDateCase
                scrollToValue
                options={timesArrayForSelectedDay}
                isWithGeneratedOnTheFlyOptions
                containerStyle={{
                  width: '411px',
                }}
                dropdownContainerStyle={availabilityPopUpTimeDropdownContainerStyle}
                value={endDate.displayTime.replaceAll(' ', '')}
                // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                setValue={(value) => changeDateTime(value, 'endTime')}
                dropId='End time*'
                label='End time*'
                customIcon={clockIcon}
                min
                customIconStyles={endDateDropDownCustomIconStyle}
              />
            </div>
            {viewType === 'availability' && showVisitTypePicker ?
              <AvailabilityTypeSettings
                onSetAvailabilityType={onSetVisitTypeGroup}
                groups={visitTypeGroups}
                selectedVisitTypeGroup={visitTypeGroup}
              />
            : null}
            {viewType === 'availability' && isInPerson ?
              <LocationSelector
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                locations={providerLocations}
                selectedLocation={selectedLocation}
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                onSelect={setSelectedLocation}
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                showError={locationSaveAttempted ? !selectedLocation : null}
                loading={locationsLoading}
              />
            : null}
          </div>
          {viewType === 'availability' ?
            <div className='availability-recurrence-container'>
              <label htmlFor='null' className='availability-recurrence-label'>
                Custom recurrence
              </label>
              <Switch
                onChange={onChangeSwitch}
                checked={isRecurrenceOn}
                offColor='#B0BDCB'
                onColor='#00A2B2'
                height={30}
                width={66}
                uncheckedIcon={<div className='availability-popUp-recurrence-switcher-off-container'> off </div>}
                checkedIcon={<div className='availability-popUp-recurrence-switcher-on-container'> on </div>}
                activeBoxShadow='#ffffff'
              />
            </div>
          : null}
          {isRecurrenceOn ?
            <RecurrenceSettings
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              setRepeatsSelectError={setRepeatsSelectError}
              endDate={endDate}
              endDateDropDownCustomIconStyle={endDateDropDownCustomIconStyle}
              calendarTimeZone={calendarTimeZone}
              clickedEndDateTime={clickedEndDateTime}
              onSetRepeatEndDateValue={onSetRepeatEndDateValue}
              repeatEndDate={repeatEndDate}
              repeatsSelectError={repeatsSelectError}
              daysOfWeekRef={daysOfWeekRef}
              isOnSelected={isOnSelected}
              repeatDays={repeatDays}
              prevSelectedDays={prevSelectedDays}
              setSelectedOption={setSelectedOption}
              onChangeButtonGroup={onSetEndDateOption}
              setPrevSelectedDays={setPrevSelectedDays}
              selectedOption={selectedOption}
              height={height}
            />
          : null}
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <PrimaryButton
            id='CalendarPopUpSaveBtn'
            btnText='Save'
            containerStyle={availabilityPopUpSaveBtnContainerStyle}
            onPress={onPressSave}
          />
        </>
      }
    />
  )
}

export default AvailabilityPopUp
